import SosSignalsPageView from '../../sections/admin/sos/SosSignalsPageView';

export default function SosAllSignalsPage() {
  return <SosSignalsPageView />;
}
